import React from "react";
import { ImageSlider, Information, HomeService, Testimonials, LatestNews, Method } from "../../FifthComponents";

const FifthHome = (props) => {
    return (
        <div>
            <ImageSlider {...props} />
            <Information {...props} />
            <HomeService {...props} />
            <Method {...props} />
            <LatestNews {...props} />
            <Testimonials {...props} />
        </div>
    )
}
export default FifthHome